import type { FunctionComponent, ReactNode } from 'react';

import { Button } from '@dr.pogodin/react-utils';

import type { ImageAssetT } from 'utils';

import secondaryButtonTheme from 'themes/Button/admin/secondary-v2.scss';

import { AssetPreview } from '../AssetPreview';

import './style.scss';

type PropsT = {
  images: Array<File | ImageAssetT | null>;
  setImages: (files: Array<File | ImageAssetT | null>) => void;
};

export const GalleryPhotos: FunctionComponent<PropsT> = ({
  images,
  setImages,
}) => {
  const itemNodes: ReactNode[] = [];

  let numPhotos = 0;

  for (let i = 0; i < images.length; ++i) {
    const image = images[i];
    if (image) ++numPhotos;
    itemNodes.push(
      <AssetPreview
        image={image}
        key={i}
        setImage={(file) => {
          const next = images.slice();
          next[i] = file;
          setImages(next);
        }}
      />,
    );
  }

  return (
    <div styleName="container">
      <h3>Gallery photos</h3>
      <p>
        Up to {images.length} photos featured in the gallery section of your
        profile.
      </p>
      <div styleName="numItems">{numPhotos} of {images.length} on profile</div>
      <div styleName="items">{itemNodes}</div>
      <div>
        <Button
          theme={secondaryButtonTheme}
          to="#your-library"
        >
          Choose from library
        </Button>
      </div>
    </div>
  );
};
